import React from "react";
import {FilterItem, FilterItemProps, InputEditor, SelectEditor} from "../tablefilter/TableFilter";
import {SearchFilter} from "../tablefilter/SearchFilter";

interface CategoryProps extends FilterItemProps {
    categories: string[];
}

function CategoryItem(props: CategoryProps) {
    return (
        <SelectEditor
            width={120}
            multiple={true}
            options={props.categories?.map(category => ({
                value: category,
                label: <span style={{display: "inline-block"}} className={"selection-item-text"}>{category}</span>
            }))}
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    )
}

function NameItem(props: FilterItemProps) {
    return (
        <InputEditor
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    )
}

interface VulSourceItemFilterProps {
    className?: string;
    values?: any;
    onChange: (values: any) => void;
    immediateMode?: boolean,
    persistentStateIdent?: string;
}

function SoftwareLicenseFilter(props: VulSourceItemFilterProps) {
    const items: FilterItem[] = [
        {
            name: "name",
            key: "name",
            label: "Name",
            render: (props) => <NameItem {...props} />
        },
        {
            name: "spdxLicenseKey",
            key: "spdxLicenseKey",
            label: "SPDX identifier",
            render: (props) => <NameItem {...props} />
        },
        {
            name: "categories",
            key: "categories",
            label: "Category",
            render: (props) => <CategoryItem {...props} categories={[
                "CLA",
                "Commercial",
                "Copyleft",
                "Copyleft Limited",
                "Free Restricted",
                "Patent License",
                "Permissive",
                "Proprietary Free",
                "Public Domain",
                "Source-available",
                "Unstated License",
            ]} />
        },
    ];

    return (
        <SearchFilter
            items={items}
            className={props.className}
            values={props.values}
            defaultValues={{name: '', spdxLicenseKey: '', categories: []}}
            persistentStateIdent={props.persistentStateIdent}
            defaultActiveFilterNames={["name", "spdxLicenseKey", "categories"]}
            immediateMode={props.immediateMode}
            onChange={props.onChange}
        />
    )
}

export default SoftwareLicenseFilter;
